import { setLocale } from 'yup'

// Rede de segurança para as mensagens padrão do yup, que saem em inglês e com o
// nome técnico do campo ("email must be a `string` type, but the final value
// was: `null`..."). Schema com mensagem própria continua usando a dele; isto só
// vale onde ninguém escreveu uma.
//
// O caso mais comum é o notType: valor vazio vindo da API (null) ou de input
// numérico apagado (NaN), que para quem preenche é "campo vazio".
setLocale({
  mixed: {
    default: 'Valor inválido.',
    required: 'Campo obrigatório.',
    defined: 'Campo obrigatório.',
    oneOf: 'Selecione uma das opções válidas.',
    notOneOf: 'Valor não permitido.',
    notType: ({ type, originalValue }) => {
      const isEmpty =
        originalValue === null ||
        originalValue === undefined ||
        (typeof originalValue === 'string' && originalValue.trim() === '')
      if (isEmpty) return 'Campo obrigatório.'
      if (type === 'number') return 'Informe um número válido.'
      if (type === 'date') return 'Informe uma data válida.'
      return 'Valor inválido.'
    }
  },
  string: {
    length: 'Deve ter exatamente ${length} caracteres.',
    min: 'Deve ter pelo menos ${min} caracteres.',
    max: 'Deve ter no máximo ${max} caracteres.',
    matches: 'Formato inválido.',
    email: 'Informe um e-mail válido.',
    url: 'Informe uma URL válida.',
    uuid: 'Valor inválido.',
    trim: 'Não pode começar nem terminar com espaço.',
    lowercase: 'Use apenas letras minúsculas.',
    uppercase: 'Use apenas letras maiúsculas.'
  },
  number: {
    min: 'Deve ser maior ou igual a ${min}.',
    max: 'Deve ser menor ou igual a ${max}.',
    lessThan: 'Deve ser menor que ${less}.',
    moreThan: 'Deve ser maior que ${more}.',
    positive: 'Deve ser maior que zero.',
    negative: 'Deve ser menor que zero.',
    integer: 'Deve ser um número inteiro.'
  },
  date: {
    min: 'Data deve ser a partir de ${min}.',
    max: 'Data deve ser até ${max}.'
  },
  array: {
    min: 'Selecione pelo menos ${min} item(ns).',
    max: 'Selecione no máximo ${max} item(ns).'
  },
  object: {
    noUnknown: 'Campo não permitido.'
  }
})
